import {
    HelpTopic,
    HelpTopicMetadataContext,
    ValidateHelpTopicRequest,
    ValidateHelpTopicResponse,
} from "src/api/Tmd.dtos";
import useBaseFormValidation from "../useBaseFormValidation";

const useHelpTopicFormValidation = (debounceMs?: number | null) =>
    useBaseFormValidation<
        HelpTopic,
        HelpTopicMetadataContext,
        ValidateHelpTopicResponse,
        ValidateHelpTopicRequest
    >(ValidateHelpTopicRequest, debounceMs);

export default useHelpTopicFormValidation;
